import { render, staticRenderFns } from "./modalita_pagamento.vue?vue&type=template&id=2019782a&"
import script from "./modalita_pagamento.vue?vue&type=script&lang=js&"
export * from "./modalita_pagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports